export const GroupEditSceneTranslation = {
  fi: {
    GroupEditScene: {
      editGroup: 'Muokkaa ryhmää',
      confirmDelete: 'Haluatko varmasti poistaa tämän ryhmän?',
      notSavedCheckFields: 'Ryhmää ei tallennettu. Tarkista kentät.',
      defaultGroupInfo: 'Kaikki ajoneuvot -ryhmässä on muutamia sääntöjä:',
      defaultGroupRuleName: 'Ryhmän nimeä ei voi muokata',
      defaultGroupRuleVehicles: 'Ajoneuvoja ei voi poistaa tästä ryhmästä',
      defaultGroupRuleMaster: 'Pääkäyttäjää ei voi poistaa tästä ryhmästä.',
    },
    Group: {
      name: 'Nimi',
      defaultName: 'Kaikki ajoneuvot',
      notificationEmail: 'Ilmoitusten vastaanottajan sähköposti',
      vehicles: 'Ajoneuvot',
      users: 'Käyttäjät',
      lockedName: 'Kaikki ajoneuvot -ryhmän nimeä ei voi muokata',
      lockedVehicle: 'Ajoneuvoja ei voi poistaa Kaikki ajoneuvot -ryhmästä',
      lockedMaster: 'Pääkäyttäjää ei voi poistaa Kaikki ajoneuvot -ryhmästä',
      noVehicles: 'Ei ajoneuvoja',
      noUsers: 'Ei käyttäjiä',
      loading: 'Ladataan...',
      nameRequired: 'Nimi on pakollinen',
      invalidEmail: 'Syötä kelvollinen sähköpostiosoite',
    },
  },
};
